import { Controller } from "@hotwired/stimulus"

// Disables the submit button until at least two listings are checked.
export default class extends Controller {
  static targets = ["checkbox", "submit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const checked = this.checkboxTargets.filter((box) => box.checked).length
    this.submitTarget.disabled = checked < 2
  }
}
